module.exports = {
	"help": "Aide",
	"productsAndServices": {
		"buying": "Acheter sur __brand__",
		"features": "$t(features::header)",
		"header": "Produits & Services",
		"selling": "Vendre sur $t(general::brand)",
		"pricing": "Tarification"
	},
	"about": {
		"aboutUs": "Au sujet d'$t(general::brand)",
		"header": "Au sujet de",
		"privacy": "Confidentialité"
	},
	"community": {
		"header": "Communauté"
	},
	"OSTimezone": "Fuseau horaire"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/footer.json5
// module id = 1983
// module chunks = 6